import { client } from 'utilities/we_apollo'

function writeCacheRemoveGroupsQuery(group, groupFilter, query) {
  try {
    const groupsQueryObject = {
      query: query,
      variables: { groupFilter: groupFilter },
    }

    const groups = client.readQuery(groupsQueryObject)

    client.writeQuery({
      data: {
        ...groups,
        groups: groups?.groups.filter((gr) => gr.id !== group.id),
      },
      ...groupsQueryObject,
    })

    return true
  } catch (error) {
    return false
  }
}

export { writeCacheRemoveGroupsQuery }
